"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var locale_manager_1 = __importDefault(require("@gin-betting/locale-manager"));
var format_1 = __importDefault(require("date-fns/format"));
var parseISO_1 = __importDefault(require("date-fns/parseISO"));
function format(date, formatStr // Output format 2020-09-30
) {
    if (formatStr === void 0) { formatStr = 'yyyy-MM-dd'; }
    if (!date)
        return '';
    return format_1.default(typeof date === 'string' ? parseISO_1.default(date) : date, formatStr, { locale: locale_manager_1.default.extensions.dateFns });
}
exports.default = format;
//# sourceMappingURL=format.js.map